/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import Slider from 'react-slick';
import {Loader} from '../../Helpers/Helpers';
import Parser from 'html-react-parser';

export default class FrameItems extends Component {

	selectMatBoard = (MatBoard) => {
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedmatBoard: MatBoard,
				matPrint: [],
				printTotal: 0,
				selectedPrintName: 'No Printing Required',
				selectedPrint: 407,
			}
		})
	};

	render() {
		const {matBoards, displayCategoryMatt, selectedmatBoard, slidesToShow, viewportWidth} = this.props;

		const selectOptions = matBoards.filter( ( item ) =>
							item.get('categories').some( ( categories ) =>
								displayCategoryMatt === categories.get('id')
							)).map((matBoard) => {
			return (
				<div key={matBoard.get('id')}>
                    <div className="frm_box">
                        <a href="#!" onClick={this.selectMatBoard.bind(this, matBoard)}>
							<i className={selectedmatBoard.get('id') === matBoard.get('id') ? "selectedImageFrame" : '' }>
								<img src={matBoard.getIn(['images', 0, 'src'])} alt={Parser(matBoard.get('name'))} />
							</i>
                        </a>
                        <p>
                        	<a href="#!" className="link" onClick={this.selectMatBoard.bind(this, matBoard)}>{Parser(matBoard.get('name'))}</a>
                        </p>
                    </div>
                </div>
			)
		})

		let slidedShow = slidesToShow;
		if (viewportWidth < 576) {
			slidedShow = 3
		}
		if (viewportWidth < 361) {
			slidedShow = 2
		}

		var settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: slidedShow,
            slidesToScroll: slidedShow,
            lazyLoad: true,
            pauseOnHover: true
        };

	    return (
	    	<div className="frm_mn_box mat-board-wrapper">
	            {this.props.matBoardsLaoded ?
	            	<Slider ref={c => this.slider = c} {...settings}>
	                	{selectOptions}
	                </Slider>
    		 	: <Loader/>
    			}
		    </div>
	    );
	}
}